
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { 
  Tooltip, 
  TooltipContent, 
  TooltipProvider, 
  TooltipTrigger 
} from '@/components/ui/tooltip';

interface SidebarNavItemProps {
  path: string;
  name: string;
  icon: React.ElementType;
  isSidebarOpen: boolean;
}

const SidebarNavItem: React.FC<SidebarNavItemProps> = ({ 
  path, 
  name, 
  icon: Icon, 
  isSidebarOpen 
}) => {
  const location = useLocation();
  
  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <li>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Link
              to={path}
              className={cn(
                "flex items-center space-x-3 px-3 py-2 rounded-md transition-all duration-200",
                isActive(path)
                  ? "bg-primary text-primary-foreground"
                  : "text-foreground hover:bg-muted"
              )}
            >
              <Icon className="h-5 w-5" />
              <span className={cn(
                "transition-opacity duration-200",
                !isSidebarOpen && "opacity-0 md:hidden"
              )}>
                {name}
              </span>
            </Link>
          </TooltipTrigger>
          <TooltipContent side="right" className={cn(isSidebarOpen && "hidden")}>
            {name}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </li>
  );
};

export default SidebarNavItem;
